
import { Dispatch } from 'app/types/redux';
/******************
 * Initial state
 */
const initialState = {
    status: 'noSession',
};

/******************
 * Non-async action types
 */

const SET_SESSION_EXTEND = 'SET_SESSION_EXTEND';
const SET_SESSION_WARNING = 'SET_SESSION_WARNING';
const SET_SESSION_END = 'SET_SESSION_END';

/******************
 * Reducer
 */
export default function session( state = initialState, action: any ) {
    switch ( action.type ) {
        case SET_SESSION_WARNING:
        case SET_SESSION_EXTEND:
        case SET_SESSION_END:
            if ( state.status === action.data ) {
                return state;
            }
            return {
                ...state,
                status: action.data,
            };
        default:
            return state;
    }
}

/******************
 * Action creators
 */

export function setSessionExtend(  ) {
    return ( dispatch: Dispatch, getState: any ) => {
        dispatch( {
            type: SET_SESSION_EXTEND,
            data: 'alive',
        } );
    };
}

export function setSessionWarning(  ) {
    return ( dispatch: Dispatch, getState: any ) => {
        dispatch( {
            type: SET_SESSION_WARNING,
            data: 'warning',
        } );
    };
}

export function setSessionEnd(  ) {
    return ( dispatch: Dispatch, getState: any ) => {
        dispatch( {
            type: SET_SESSION_END,
            data: 'end',
        } );
    };
}
